<template>
  <div class="chart-container">
    <Bar :data="chartData" :options="computedOptions" />
  </div>
</template>

<script>
import '@/services/chart-register.js';
import { Bar } from 'vue-chartjs';
import { CHART_COLORS } from '@/services/chart-register.js';

export default {
  name: 'BillingBarChart',
  components: { Bar },
  props: {
    labels: { type: Array, default: function () { return []; } },
    values: { type: Array, default: function () { return []; } },
    label: { type: String, default: 'Spend' },
    color: { type: String, default: CHART_COLORS.primary },
    currency: { type: String, default: '' },
    showLegend: { type: Boolean, default: false },
    height: { type: Number, default: 280 },
    autoSkip: { type: Boolean, default: true },
    maxTicksLimit: { type: Number, default: 10 }
  },
  computed: {
    chartData: function () {
      return {
        labels: this.labels,
        datasets: [{
          label: this.label,
          data: this.values,
          backgroundColor: this.color,
          borderRadius: 4,
          maxBarThickness: 28
        }]
      };
    },
    computedOptions: function () {
      var self = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: this.showLegend },
          tooltip: {
            callbacks: {
              label: function (ctx) {
                var val = Number(ctx.parsed.y);
                var formatted = val.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                return self.label + ': ' + (self.currency || '') + formatted;
              }
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            border: { display: false },
            ticks: {
              color: CHART_COLORS.slate,
              font: { size: 14, weight: '500' },
              maxRotation: 45,
              minRotation: 0,
              autoSkip: this.autoSkip,
              maxTicksLimit: this.maxTicksLimit
            }
          },
          y: {
            grid: { color: CHART_COLORS.gridLine },
            border: { display: false },
            ticks: {
              color: CHART_COLORS.slate,
              font: { size: 12 },
              callback: function (val) {
                if (Math.abs(val) >= 1000) return (val / 1000).toFixed(0) + 'k';
                return val;
              }
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.chart-container :deep(canvas) {
  width: 100% !important;
  height: 100% !important;
}
</style>
